import './Docs.css'
import React from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'

const Doc = ({ meta, html }) => {
  return (
    <div className='Doc'>
      <Helmet
        title={meta.title}
        meta={[
          // {'name': 'description', 'content': meta.description},
          {'property': 'og:type', 'content': 'article'},
          {'property': 'og:title', 'content': meta.title},
          // {'property': 'og:description', 'content': meta.description},
          {'property': 'og:image', 'content': '/assets/smallchatdocsmeta.png' },
        ]}
    />
      <div className='Doc_content' dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  )
}

Doc.displayName = 'Doc'

export default Doc



// WEBPACK FOOTER //
// ./src/Doc.js